/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "../style/Footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faTwitter,
  faGoogle,
  faInstagram,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import {
  faCopyright,
  faLocationDot,
  faPhone,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

const MAP_URL =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3564.40494245704!2d88.44847757449682!3d26.699507469222247!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39e4411204618f15%3A0xe137090f018f693c!2sEBS%20Software%20Solution!5e0!3m2!1sen!2sin!4v1779135065938!5m2!1sen!2sin";

const Footer = () => {
  const footerLinks = [
    { label: "About us", path: "/About" },
    { label: "Products", path: "/Product" },
    { label: "Customized Software", path: "/custom" },
    { label: "Web & Mobile App", path: "/website" },
    { label: "Contact us", path: "/contactus" },
  ];

  const contactItems = [
    {
      icon: faLocationDot,
      title: "Office Address",
      text: "EBS IT Park,Ganesh Street,Near Uttar Banga Sambad Press,Madhya Santi Nagar, Siliguri, West Bengal, INDIA, Pin-734004",
    },
    {
      icon: faPhone,
      title: "Sales & Support",
      text: "+91 97337 21111, 99320 13501",
    },
    {
      icon: faEnvelope,
      title: "Email",
      text: "info@ebssoftware.co.in | ebs.slg@gmail.com",
    },
  ];

  const socialLinks = [
    {
      label: "Facebook",
      href: "https://www.facebook.com/EBSSoftware/",
      icon: faFacebookF,
    },
    {
      label: "Twitter",
      href: "https://twitter.com/EbsSoftware",
      icon: faTwitter,
    },
    {
      label: "Google",
      href: "#",
      icon: faGoogle,
    },
    {
      label: "Instagram",
      href: "https://www.instagram.com/ebssiliguri/",
      icon: faInstagram,
    },
    {
      label: "LinkedIn",
      href: "#",
      icon: faLinkedin,
    },
  ];

  return (
    <footer className="ebs-footer-wrapper">
      <section className="ebs-footer-map-wrap">
        <iframe
          src={MAP_URL}
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="EBS Software Solution Google Map"
        ></iframe>
      </section>

      <section className="ebs-footer-main">
        <Container fluid="lg">
          <div className="ebs-footer-top">
            <div className="ebs-footer-brand">
              <span>Software Development Company</span>
              <h2>EBS Software Solution</h2>
              <p>
                Our world-class management team is constantly sharpening its
                techniques and refining its approaches to help our clients
                strike the right balance between cost and quality, and we look
                forward to the contractual side of a business agreement to see
                the &quot;softer&quot; issues that impact our clients&apos;
                success.
              </p>
            </div>
          </div>

          <Row className="g-3 ebs-footer-contact-row">
            {contactItems.map((item) => (
              <Col lg={4} md={6} key={item.title}>
                <div className="ebs-footer-contact-card">
                  <div className="ebs-footer-contact-icon">
                    <FontAwesomeIcon icon={item.icon} />
                  </div>
                  <div>
                    <h3>{item.title}</h3>
                    <p>{item.text}</p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>

          <div className="ebs-footer-links">
            {footerLinks.map((item) => (
              <Link key={item.path} to={item.path} className="ebs-footer-link">
                {item.label}
              </Link>
            ))}
          </div>

          <div className="ebs-footer-social">
            {socialLinks.map((item) => (
              <a
                key={item.label}
                href={item.href}
                aria-label={item.label}
                target={item.href === "#" ? undefined : "_blank"}
                rel={item.href === "#" ? undefined : "noopener noreferrer"}
              >
                <FontAwesomeIcon icon={item.icon} />
              </a>
            ))}
          </div>

          <div className="ebs-footer-bottom">
            <span>Copyright</span>
            <FontAwesomeIcon icon={faCopyright} />
            <span>
              {new Date().getFullYear()} EBS Software Solution, All Rights
              Reserved.
            </span>
          </div>
        </Container>
      </section>
    </footer>
  );
};

export default Footer;
